import React from 'react';
import "./footer.css";

const footer = () => {
  return (
    <div className='footer'>
      <div>Movie App</div>
      <div>&copy 2022, Movie,Inc,or its affilates</div>
    </div>
  )
}

export default footer
